export function getRedirectTarget(defaultTarget = '/'): string {
  const params = new URLSearchParams(window.location.search)
  const redirect = params.get('redirect')
  if (!redirect?.startsWith('/')) {
    return defaultTarget
  }

  try {
    const target = new URL(redirect, window.location.origin)
    if (target.origin !== window.location.origin) {
      return defaultTarget
    }

    return `${target.pathname}${target.search}${target.hash}`
  } catch {
    return defaultTarget
  }
}

export function navigateTo(path: string) {
  window.location.assign(path)
}

export function getSearchToken(): string | null {
  const params = new URLSearchParams(window.location.search)
  return params.get('token')
}
